// config
import * as http from 'utils/http';
import config from 'config';

const createCarrierUser = async ({ carrierUserDto }) => {
  return http.post(`${config.BASE_ROUTE}api/users/`, carrierUserDto);
};

export default createCarrierUser;
